import React from 'react';

const AllCategoriesSection = (props) => {
  const { data } = props;
  return (
    <section className="donate-your-bills Cause ideas inspiration">
      <div className="container">
        <h2 className="main-heading text-center mb-5">Cause ideas Inspiration</h2>
        <div className="row no-gutters">
          {
            data && data.length ?
              data.map(({ image, name, id }, index) => {
                return (
                  <div key={index} className="col-lg-3 col-md-4 col-sm-6 ">
                    <a href={id === 1 ? `/category/${id}` : `/other-category/${id}`}>
                      <div className="bills_box">
                        <img alt='tst' src={`${process.env.REACT_APP_BACKEND_BASE_URL}/${image}`} />
                        <h3>{name}</h3> </div>
                    </a>
                  </div>
                );
              }) : ''
          }
        </div>
      </div>
    </section>
  );
};

export default AllCategoriesSection